import getDocument from '../get-document';

export default function getStaticRev() {
  const document = getDocument();

  if (!document || !document.getElementById) {
    return null;
  }

  const staticRev = document.getElementById('static-rev');

  if (!staticRev) {
    return null;
  }

  return staticRev.value;
}
